/* eslint-disable */
import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'add-interview-quiz',
  components: {
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data() {
    return {
      quizData: {
        name: '',
        category: '',
        instruction: '',
        quiz_number: '',
        time_limit:90,
        create_datetime:'',
        end_datetime:'',
        is_active:false,
        is_visible:false,
        testing_enabled:false
      },
      unitListState: [],
      submitted:false,
      courseDetais:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:'',
      code:'',
      minDatetime:new Date().toISOString(),
    }
  },
  computed: {
  },
  mounted() {
    this.$store.dispatch('getIvQuizUniInfoAction').then((res) => {
      this.unitListState = res.data.data.results
    })
  },
  methods: {
    clearEndTimePointFun(){
      this.quizData.end_datetime = ''
    },
    validateCreateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            connected_to_unit: this.quizData.category,
            // quiz_number:this.quizData.quiz_number,
            // time_limit:this.quizData.time_limit,
            start_time:this.quizData.create_datetime,
            code:this.code,
            is_interview:true
          }
          if(this.quizData.end_datetime != null && this.quizData.end_datetime != ''){
            data.end_time = this.quizData.end_datetime;
          }else{
            data.end_time = null
          }
          this.$store.dispatch('postInterviewQuizInfoAction', data)
          .then((res) => {
            this.quizData.name = '',
            this.quizData.instruction = '',
            this.quizData.category = '',
            this.quizData.time_limit = '',
            this.quizData.create_datetime = '',
            this.quizData.end_datetime = '',
            this.quizData.is_visible = false
            this.quizData.is_active  = false,
            this.code = '',
            toast.success(res.data.msg);
            this.$validator.reset();
            this.$router.push('/interview/quiz/' )
            })
            .catch((err) => {})
          return
        }
      });
    },
  },
  watch: {
  }
}